function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import NotificationIcon from '@domain-group/fe-co-icon/lib/js/notification';
import SignInType from '@domain-group/fe-allhomes-library/lib/enums/sign-in-type';
import propertyAlertWrapper from './wrapper';
import * as styles from './old-property-alert-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class OldPropertyAlertButton extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "openSignIn", event => {
      event.preventDefault();
      event.stopPropagation();
      this.props.onPropertyAlertClick();
      if (this.props.isSignedIn) {
        this.redirect();
      } else {
        this.props.openSignIn(SignInType.PROPERTY_ALERT).then(success => {
          if (success) {
            this.redirect();
          }
        });
      }
    });
    _defineProperty(this, "redirect", () => {
      if (typeof window !== 'undefined') {
        window.location.href = this.props.targetUrl;
      }
    });
  }
  /* eslint-disable jsx-a11y/anchor-is-valid */
  render() {
    var mobile = this.props.media.mobile;
    if (this.props.type === 'link') {
      return ___EmotionJSX("span", null, ___EmotionJSX("a", {
        href: mobile ? '#' : this.props.targetUrl,
        css: styles.link,
        onClick: mobile ? this.openSignIn : this.props.onPropertyAlertClick,
        rel: "nofollow"
      }, this.props.buttonLabel));
    }
    return ___EmotionJSX("div", null, ___EmotionJSX("a", {
      css: styles.propertyAlertButton({
        hasBorder: !this.props.noBorder
      }),
      href: mobile ? '#' : this.props.targetUrl,
      onClick: mobile ? this.openSignIn : this.props.onPropertyAlertClick,
      rel: "nofollow"
    }, ___EmotionJSX(NotificationIcon, {
      size: "regular"
    }), ___EmotionJSX("span", {
      css: styles.text({
        isResponsive: this.props.responsive
      })
    }, this.props.buttonLabel)));
  }
}
OldPropertyAlertButton.propTypes = {
  buttonLabel: PropTypes.string,
  targetUrl: PropTypes.string,
  responsive: PropTypes.bool,
  noBorder: PropTypes.bool,
  onPropertyAlertClick: PropTypes.func,
  isSignedIn: PropTypes.bool,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  type: PropTypes.string,
  openSignIn: PropTypes.func
};
OldPropertyAlertButton.defaultProps = {
  buttonLabel: 'Property alert',
  responsive: false,
  noBorder: false,
  onPropertyAlertClick: () => {},
  targetUrl: '/property-alerts',
  isSignedIn: false,
  media: {
    mobile: true
  },
  type: '',
  openSignIn: () => Promise.resolve(false)
};
export default propertyAlertWrapper(OldPropertyAlertButton);
export { OldPropertyAlertButton as BaseOldPropertyAlertButton };